import * as React from 'react';
import { Button, Empty, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { downloadExcel, getReport } from './api';
import HistoryTable from './HistoryTable';
import ReportBody from './ReportBody';
import ShareControls from './ShareControls';

const ReportPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const reportId = id ? Number(id) : NaN;
    const navigate = useNavigate();
    const [downloading, setDownloading] = React.useState(false);
    const { data, isLoading, isError } = useQuery({
        queryKey: ['social-metrics-report', reportId],
        queryFn: () => getReport(reportId),
        enabled: Number.isFinite(reportId) && reportId > 0,
    });

    const onDownload = async () => {
        if (!data) return;
        setDownloading(true);
        try {
            const account = data.display_name || data.account_input || 'account';
            await downloadExcel(data.id, `social-metrics-${data.platform}-${account}.xlsx`);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div>
            <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => navigate('/reporting/social-metrics')} style={{ paddingLeft: 0 }}>
                New report
            </Button>
            {isLoading ? <div style={{ padding: 48, textAlign: 'center' }}><Spin /></div> : null}
            {!isLoading && (isError || !data?.snapshot) ? <Empty description="Report not found" /> : null}
            {data?.snapshot ? (
                <ReportBody
                    report={data.snapshot}
                    downloading={downloading}
                    onDownload={onDownload}
                    headerExtra={<ShareControls reportId={data.id} shareToken={data.share_token} />}
                />
            ) : null}
            <HistoryTable activeId={data?.id} />
        </div>
    );
};

export default ReportPage;
